import React from "react";
import { clearConsentCookie, unloadTawkTo } from "../../../CookieConsentForm/CookieConsentForm";

export default function PortalFooter() {
  const openCookieSettings = (event) => {
    event.preventDefault();

    unloadTawkTo();
    clearConsentCookie();
    
    window.dispatchEvent(
      new CustomEvent("show-cookie-settings")
    );
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.links}>
          {/* <a
            href="/contact"
            style={styles.link}
          >
            Contact Us
          </a> */}

          <a
            href="https://schooltour.ie/booking-conditions/" target="_blank" rel="noopener noreferrer"
            style={styles.link}
          >
            Booking Conditions
          </a>

          <a
            href="https://schooltour.ie/gdpr/" target="_blank" rel="noopener noreferrer"
            style={styles.link}
          >
            GDPR Information
          </a>

          <a
            href="/#"
            style={styles.link}
            onClick={openCookieSettings}
          >
            Cookie Settings
          </a>
        </div>

        <div style={styles.copyright}>
          © {new Date().getFullYear()} The School Tour Company. School Tour Company is a trading name of Discover School Tours Ltd, a company registered in Ireland..
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: "auto",
    borderTop: "1px solid #e5e7eb",
    background: "#f9fafb",
    padding: "24px 16px",
    width: "100%",
    maxWidth: "100%"
  },

  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },

  links: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
  },

  link: {
    color: "#2563eb",
    textDecoration: "none",
    fontSize: "0.95rem",
    cursor: "pointer",
  },

  copyright: {
    color: "#6b7280",
    fontSize: "0.85rem",
  },
};